import ManagementNavigation from './ManagementNavigation';

export default ManagementNavigation;
